'use client'
import { useAtomValue } from 'jotai'
import { translationState } from '@/components/Atoms/TranslationAtom';
import {dictionaryType} from "@/lib/definitions/definitions";

export function useTranslation() {

    const translation = useAtomValue(translationState);

    const t = (name: string, variable?: string): string => {
        const keys = name?.split('.');
        let result: string | dictionaryType = translation.dictionary;

        for (let key of keys) {
            if (result[key] !== undefined) {
                // Vérifier si le résultat est une chaîne avant d'appeler replace()
                if (typeof result[key] === 'string') {
                    if (variable) {
                        result = (result[key] as string).replace('$VAR$', variable);
                    } else {
                        result = result[key] as string;
                    }
                } else {
                    // Si ce n'est pas une chaîne, continuez à explorer l'objet
                    result = result[key] as dictionaryType;
                }
            } else {
                return variable ? name.replace('$VAR$', variable) : name;
            }
        }

        // Si le résultat final est un objet, retourner le chemin complet
        if (typeof result === 'object' && result !== null) {
            return name;
        }

        return result as string;
    };

    return t;
}
